// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"bed41aaf","304":"8226e9b7","326":"e5a1814c","504":"c867ed23","569":"c867ed23","597":"c867ed23","635":"bed41aaf","830":"0a081535"}[chunkId] + ".chunk.css";
};